import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Thanks from "./pages/Thanks";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminKanban from "./pages/admin/AdminKanban";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminAdsSetup from "./pages/admin/AdminAdsSetup";
import AdminLeadDetail from "./pages/admin/AdminLeadDetail";
import AdminManual from "./pages/admin/AdminManual";
import AdminDiagnostic from "./pages/admin/AdminDiagnostic";
import AdminEmails from "./pages/admin/AdminEmails";
import AdminSubscribers from "./pages/admin/AdminSubscribers";
import AdminCampaigns from "./pages/admin/AdminCampaigns";
import AdminCampaignDetail from "./pages/admin/AdminCampaignDetail";
import AdminCampaignEditor from "./pages/admin/AdminCampaignEditor";
import AdminCalculadora from "./pages/admin/AdminCalculadora";
import AdminLayout from "./components/admin/AdminLayout";
import ProtectedAdmin from "./components/admin/ProtectedAdmin";
import { Toaster } from "sonner";

// Capture UTM params on first load and store in sessionStorage
function useUTMCapture() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const utmKeys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
      const existing = JSON.parse(sessionStorage.getItem("fs_utm") || "{}");
      let updated = { ...existing };
      let changed = false;
      utmKeys.forEach((k) => {
        const v = params.get(k);
        if (v && updated[k] !== v) {
          updated[k] = v;
          changed = true;
        }
      });
      if (!updated.referrer && document.referrer) {
        updated.referrer = document.referrer;
        changed = true;
      }
      if (changed) sessionStorage.setItem("fs_utm", JSON.stringify(updated));
    } catch (e) {
      // ignore
    }
  }, []);
}

function AppInner() {
  useUTMCapture();
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Home />} />
      <Route path="/gracias" element={<Thanks />} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<ProtectedAdmin />}>
        <Route element={<AdminLayout />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/pipeline" element={<AdminKanban />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/ads-setup" element={<AdminAdsSetup />} />
          <Route path="/admin/calculadora" element={<AdminCalculadora />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/leads/:id" element={<AdminLeadDetail />} />
          <Route path="/admin/emails" element={<AdminEmails />} />
          <Route path="/admin/subscribers" element={<AdminSubscribers />} />
          <Route path="/admin/campaigns" element={<AdminCampaigns />} />
          <Route path="/admin/campaigns/new" element={<AdminCampaignEditor />} />
          <Route path="/admin/campaigns/:id" element={<AdminCampaignDetail />} />
          <Route path="/admin/campaigns/:id/edit" element={<AdminCampaignEditor />} />
          <Route path="/admin/manual" element={<AdminManual />} />
          <Route path="/admin/diagnostic" element={<AdminDiagnostic />} />
        </Route>
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppInner />
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
